"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableActions = exports.RTEModals = exports.Commands = void 0;
var Commands;
exports.Commands = Commands;

(function (Commands) {
  Commands["blockquote"] = "blockquote";
  Commands["bold"] = "bold";
  Commands["bulletList"] = "bulletList";
  Commands["clearFormat"] = "clearFormat";
  Commands["code"] = "code";
  Commands["fullScreen"] = "fullScreen";
  Commands["heading"] = "heading";
  Commands["horizontalRule"] = "horizontalRule";
  Commands["image"] = "image";
  Commands["italic"] = "italic";
  Commands["link"] = "link";
  Commands["listItem"] = "listItem";
  Commands["orderedList"] = "orderedList";
  Commands["paragraph"] = "paragraph";
  Commands["underline"] = "underline";
  Commands["keyboardShortcuts"] = "keyboardShortcuts";
  Commands["strike"] = "strike";
  Commands["history"] = "history";
  Commands["clipboard"] = "clipboard";
  Commands["textAlign"] = "textAlign";
  Commands["indent"] = "indent";
  Commands["table"] = "table";
  Commands["fontColor"] = "fontColor";
  Commands["highlight"] = "highlight";
})(Commands || (exports.Commands = Commands = {}));

var TableActions;
exports.TableActions = TableActions;

(function (TableActions) {
  TableActions["Insert"] = "insert";
  TableActions["Edit"] = "Edit";
  TableActions["AddRow"] = "addRow";
  TableActions["AddColumn"] = "addColumn";
  TableActions["RemoveRow"] = "removeRow";
  TableActions["RemoveColumn"] = "removeColumn";
  TableActions["ToggleHeaderRow"] = "toggleHeaderRow";
  TableActions["ToggleHeaderColumn"] = "toggleHeaderColumn";
})(TableActions || (exports.TableActions = TableActions = {}));

var RTEModals;
exports.RTEModals = RTEModals;

(function (RTEModals) {
  RTEModals["Image"] = "image";
  RTEModals["KeyboardShortcuts"] = "keyboard";
  RTEModals["Link"] = "link";
  RTEModals["Table"] = "table";
  RTEModals["EditTable"] = "editTable";
  RTEModals["None"] = "none";
})(RTEModals || (exports.RTEModals = RTEModals = {}));